import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#2A2A2A] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/900448bc-e124-4164-bbae-25c5d6a7b547.png"
              alt="Sodrel Logistics"
              className="h-12 w-auto mb-4"
            />
            <p className="text-[#9CA3AF] text-sm mb-6 leading-relaxed">
              110 years of logistics excellence, moving your business forward with reliable transportation solutions.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#FF8C42] transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#FF8C42] transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#FF8C42] transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-[#FF8C42] text-sm font-semibold uppercase tracking-wider mb-4">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-[#9CA3AF] text-sm hover:text-[#FF8C42] transition-colors duration-200 cursor-pointer"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/products-services"
                  className="text-[#9CA3AF] text-sm hover:text-[#FF8C42] transition-colors duration-200 cursor-pointer"
                >
                  Products & Services
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-[#9CA3AF] text-sm hover:text-[#FF8C42] transition-colors duration-200 cursor-pointer"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-[#9CA3AF] text-sm hover:text-[#FF8C42] transition-colors duration-200 cursor-pointer"
                >
                  Careers
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-[#FF8C42] text-sm font-semibold uppercase tracking-wider mb-4">
              Policies
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/return-policy"
                  className="text-[#9CA3AF] text-sm hover:text-[#FF8C42] transition-colors duration-200 cursor-pointer"
                >
                  Return Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-[#9CA3AF] text-sm hover:text-[#FF8C42] transition-colors duration-200 cursor-pointer"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-[#FF8C42] text-sm font-semibold uppercase tracking-wider mb-4">
              Get In Touch
            </h3>
            <div className="space-y-4">
              <a
                href="tel:+13172460584"
                className="flex items-center text-white text-lg font-medium hover:text-[#FF8C42] transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-phone-fill text-[#FF8C42] mr-2"></i>
                +1 (317) 246-0584
              </a>
              <a
                href="mailto:sodrel@michaellogistics.com"
                className="flex items-center text-[#9CA3AF] text-sm hover:text-[#FF8C42] transition-colors duration-200 cursor-pointer break-all"
              >
                <i className="ri-mail-fill text-[#FF8C42] mr-2"></i>
                sodrel@michaellogistics.com
              </a>
              <p className="text-[#9CA3AF] text-sm flex items-start">
                <i className="ri-map-pin-fill text-[#FF8C42] mr-2 mt-1"></i>
                <span>1 Sodrel Dr, Jeffersonville, IN 47129-2826</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-[#9CA3AF] text-sm">
              © 2024 Sodrel Logistics LLC. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link
                to="/privacy-policy"
                className="text-[#9CA3AF] text-sm hover:text-[#FF8C42] transition-colors duration-200 cursor-pointer"
              >
                Privacy Policy
              </Link>
              <Link
                to="/return-policy"
                className="text-[#9CA3AF] text-sm hover:text-[#FF8C42] transition-colors duration-200 cursor-pointer"
              >
                Return Policy
              </Link>
            </div>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#9CA3AF] text-sm hover:text-[#FF8C42] transition-colors duration-200 cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;